/* eslint-disable no-console */
import React from 'react';
import { Box, Button, Group, Text, Space, Center, Divider, Stack, Container } from '@mantine/core';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { sendRequest } from '../../services/services';

const CashierAccount = ({ profile, amountTotal }) => {
  const navigate = useNavigate();
  const now = dayjs();

  const status = `?is_online=${false}`;

  const onPrint = () => {
    sendRequest(`/cashier/change-status${status}`, 'post')
      .then(({ msg }) => {
        if (msg === 'Profile online status updated successfully!') {
          console.log('err', msg);
        }
        return sendRequest(`/cashier/logout`, 'PATCH');
      })
      .then(() => {
        window.print();
        localStorage.setItem('token', '');
        navigate('/');
        window.location.reload();
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          console.log('err', err?.response?.data?.code);
        }
      });
  };

  const totalAmountData = Number(amountTotal?.cash) + Number(amountTotal?.card);
  return (
    <div>
      {/* <Button className="no-printme" onClick={() => onPrint()}>
        Print Data
      </Button> */}
      <Button
        style={{ backgroundColor: '#01AA84' }}
        // onClick={() => {
        //   localStorage.setItem('token', '');
        //   '/login';
        // }}
        className="no-printme"
        onClick={() => onPrint()}
      >
        Confirm to Shift End
      </Button>
      <Box>
        <Container className="printme" style={{ marginTop: '-760px' }}>
          <Center>
            <Text weight={500} py="sm">
              MAWQFI
            </Text>
          </Center>
          <Group position="apart" py="sm">
            <Text weight={500}>Cashier Name</Text>
            <Text weight={500}>{profile?.name}</Text>
          </Group>

          <Group position="apart" py="sm">
            <Text weight={500}>Site</Text>
            <Text weight={500}>
              {profile?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.name}
            </Text>
          </Group>

          <Group position="apart" py="sm">
            <Text weight={500}>Shift start time</Text>
            <Text weight={500}>{dayjs(profile?.online_from).format('DD/MM/YY hh:mma')}</Text>
          </Group>
          <Group position="apart" py="sm">
            <Text weight={500}>Shift end time</Text>
            <Text weight={500}>{now.format('DD/MM/YY hh:mma')}</Text>
          </Group>
          <Divider my="sm" variant="dotted" />

          <Text weight={500} py="sm">
            Accounting Summary
          </Text>
          <Group>
            <Stack>
              <Text weight={500}>Cash</Text>
              <Text weight={500}>Total</Text>
            </Stack>
            <Divider orientation="vertical" />
            <Stack>
              <Text weight={500}>Operations</Text>
              <Text weight={500}>
                {Number(amountTotal?.cash_count).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </Stack>
            <Divider orientation="vertical" />
            <Stack>
              <Text weight={500}>Amount</Text>
              <Text weight={500}>
                {Number(amountTotal?.cash).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </Stack>
          </Group>
          <Divider my="sm" variant="dotted" />
          <Group>
            <Stack>
              <Text weight={500}>Card</Text>
              <Text weight={500}>Total</Text>
            </Stack>
            <Divider orientation="vertical" />
            <Stack>
              <Text weight={500}>Operations</Text>
              <Text weight={500}>
                {Number(amountTotal?.card_count).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </Stack>
            <Divider orientation="vertical" />
            <Stack>
              <Text weight={500}>Amount</Text>
              <Text weight={500}>
                {Number(amountTotal?.card).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </Stack>
          </Group>
          <Space h="md" />
          <Divider my="sm" variant="dotted" />

          <Text weight={500} py="sm">
            Checking Cashier
          </Text>
          <Group position="apart" py="sm">
            <Text weight={500}>Total Cash Amount</Text>
            <Text weight={500}>
              {Number(amountTotal?.cash).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </Group>
          <Group position="apart" py="sm">
            <Text weight={500}>Total Card Amount</Text>
            <Text weight={500}>
              {Number(amountTotal?.card).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </Group>
          <Divider my="sm" variant="dotted" />

          <Group position="apart" py="sm">
            <Text weight={500}>Accounting Summary</Text>
            <Text weight={500}>
              {totalAmountData.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </Group>
        </Container>
      </Box>
    </div>
  );
};
export default CashierAccount;
